export default ({
  couponRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const coupons = await couponRepository.fetchCoupons({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ coupons})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
